module.exports = __webpack_public_path__ + "static/media/calendar-check.12368b0d.svg";